import { forwardRef } from "react";
import { ReactComponent as ReverseIcon } from "../../assets/icons/general/reverse.svg";
import useAuth from "../../hooks/Auth/useAuth";


const ReverseCartIcon = forwardRef(function ReverseCartIcon(
  { cartNumber, onStartReverse, ...props },
  ref
) {
  const { cartsLocationsArr } = useAuth();

  const cart = cartsLocationsArr.find(cart => cart.cart_number === cartNumber);
  const cartMotionStatus = cart?.path_status === 'DRIVING' ? true : false;

  if(cartMotionStatus) return null;

  return (
    <>
      <span
        ref={ref}
        {...props}
        onClick={() => {
          if (typeof onStartReverse === "function") onStartReverse(cartNumber);
        }}
      >
        <ReverseIcon width={24} height={24} />
      </span>
    </>
  );
});

export default ReverseCartIcon;
